document.addEventListener("DOMContentLoaded", function() {
  (function($) {
    if ($(".packages-navbar__tab").length) {
      packageArrowSetup();
      // packageTitleInit();
      //
      // $(window).resize(packageTitles);
      // $(window).scroll(packageTitles);
      // $(".package-content__container").scroll(packageTitles);

      $(".packages-navbar__tab").click(function() {
        var that = $(this),
            content = $(that.attr("data-content-id")),
            id = content.selector;
        // remove classes from all
        $(".packages-navbar__tab").removeClass("packages-navbar__tab--active");
        $(".packages-partial").removeClass("packages-partial--active");
        // add class to the one we clicked
        that.addClass("packages-navbar__tab--active");
        $("#" + id).addClass("packages-partial--active");
        // packageTitleInit();
        packageArrowSetup();
      });

      $(".package-content__arrows").click(arrowClick); // set listener for when arrows are clicked.
      $(".package-content__container").scroll(packageArrowSetup);

      function packageArrowSetup() {
        var arrows = $(".packages-partial--active .package-content__arrows");

        if (arrows.length) {
          var parent = arrows.eq(0).parent(),
              packageTitle = parent.find('.package-titles'),
              packageTitleHeight = packageTitle.height(),
              negativeTopOffset = 16,
              parentScrollLeft = parent.scrollLeft()
          ;

          arrows.css("top", packageTitleHeight + 55 - negativeTopOffset + "px"); // 55 is the padding-top for the parent container
          arrows.eq(0).css("left", parentScrollLeft);
          arrows.eq(1).css("right", -parentScrollLeft);

          packageArrowVisible();
        }
      }

      function packageArrowVisible() {
        var arrows = $(".packages-partial--active .package-content__arrows"),
            parent = arrows.parent(),
            parentWidth = parent.width(),
            parentScrollLeft = parent.scrollLeft(),
            contentWidth = parent.find(".package-titles").width(),
            leftArrow = arrows.eq(0),
            rightArrow = arrows.eq(1)
        ;

        if (parentScrollLeft > 0) {
          leftArrow.show();
        } else {
          leftArrow.hide();
        }

        if (parentScrollLeft + parentWidth < contentWidth) {
          rightArrow.show();
        } else {
          rightArrow.hide();
        }
      }

      function arrowClick() {
        var self = $(this),
            parent = self.parent(),
            parentScroll = parent.scrollLeft(),
            packageCount = parent.find(".package-content__first").length,
            amountToScroll = (parent.width() * 0.8),
            maxScroll = parent.find(".package-titles").width()
        ;

        if (self.hasClass("package-content__arrows--right")) { // It's the right arrow
          parent.animate({scrollLeft: parentScroll + amountToScroll + "px"}, 500, "linear")
        } else {
          parent.animate({scrollLeft: parentScroll - amountToScroll + "px"}, 500, "linear")
        }
      }


      // function packageTitleInit() {
      //   var packageTitleColumns = $(".packages-partial--active .package-titles").children()
      //       fixedContainer = $("#packageFixedTitles .packages-fixed__container"),
      //       first = " packages-fixed__cell--first"
      //   ;
      //   fixedContainer.html("");
      //
      //   packageTitleColumns.each(function() {
      //     var that = $(this);
      //
      //     fixedContainer.append("<div class=\"packages-fixed__cell" + first + "\">" + that.html() + "</div>");
      //
      //      first = "";
      //   });
      //
      //   packageTitles();
      // }

      // function packageTitles() {
      //   var menuHeight = $(".primary-nav-menu")[0].clientHeight,
      //       packageTitles = $(".packages-partial--active .package-titles"),
      //       packageContainer = $(".packages-partial--active .package-content__container")
      //       packageContainerLeft = packageContainer.scrollLeft();
      //       fixedContainer = $("#packageFixedTitles"),
      //       fixedContainerChildren = fixedContainer.children().eq(0).children(),
      //       fixedContainerHeader = $(".packages-fixed__cell--first"),
      //       titleRowPosition = packageTitles.position().top - $(document).scrollTop(),
      //       generalAdmissionPosition = $(".packages-partial--active .general_admission").position().top - $(document).scrollTop(),
      //       counter = 0
      //   ;
      //
      //   if (window.innerWidth < 640) {
      //     // Don't show for mobile
      //     fixedContainer.css("display", "none");
      //   } else {
      //     // Set up container to match table styles
      //     fixedContainer.css({"width": packageContainer.width(), "left": ($(window).width()/2) - (packageContainer.width()/2)});
      //
      //     var totalWidth = 0;
      //     packageTitles.children().each(function() {
      //       var that = $(this),
      //           height = that.outerHeight() + "px",
      //           width = that.outerWidth() + "px"
      //       ;
      //
      //       totalWidth = totalWidth + that.outerWidth();
      //
      //       fixedContainerChildren[counter].style.height = height;
      //       fixedContainerChildren[counter].style.width = width;
      //
      //       counter++;
      //     });
      //
      //     fixedContainer.children().css({"width": totalWidth + "px", "left": "-" + packageContainerLeft + "px"});
      //     fixedContainerHeader.find('.package-content__header').css("line-height", fixedContainerHeader.height() + "px");
      //     fixedContainer.css("top", menuHeight + "px");
      //
      //     if ( (titleRowPosition - menuHeight < 0) && (menuHeight + fixedContainer.height() < generalAdmissionPosition) ) {
      //       fixedContainer.css({"display": "block", "opacity": 1});
      //       packageTitles.css("opacity", 0);
      //     } else {
      //       if (menuHeight + fixedContainer.height() < generalAdmissionPosition) {
      //         fixedContainer.css({"display": "none", "opacity": 0});
      //       } else {
      //         fixedContainer.fadeOut();
      //       }
      //       packageTitles.css("opacity", 1);
      //     }
      //   }
      // }
    }

    function tiFilter(){
        // reset classes
        $('.package-content').attr('class','package-content');
        $('.pcc-slider').attr('class','pcc-slider');
        $('.ti-option').removeClass('data-dining data-circle data-seating data-tour');
    
        // reset applied
        $('#tiApplied div').remove();
    
        // loop through filters
        $('.ti-filter').each(function(){
            // create variable of filter
            var tiFilterName = $(this).attr('data-filter');
    
            // if filter has options select, add class to #content
            if ( $(this).find('input:checked').length ){
                // add class to main content div
                $('.package-content, .pcc-slider').addClass(tiFilterName);
    
                // loop through selected inputs
                $(this).find('input:checked').each(function(){
                    // add class to options with that attribute
                    $('.ti-option['+tiFilterName+'*="'+$(this).val()+'"]').addClass(tiFilterName);
    
                    // add button below orange filter bar
                    $('#tiApplied').prepend('<div class="ti-filter-applied"><div class="ti-filter-app-button" data-filter="'+tiFilterName+'" data-val="'+$(this).val()+'"><span class="ti-filter-text">'+$(this).closest('.ti-filter-opt').text()+'</span><span class="ti-filter-app-remove filter-sprite remove-sprite"></span></div></div>');
                });
            }
        });
    
        // show or hide applied filters
        if ( !$('#tiApplied .ti-filter-applied').length ){
            $('#tiApplied').hide();
        }else {
            $('#tiApplied').show();
        }
    
        // show or hide headers
        if ( !$('.ti-option[data-feature*="guide"]:visible').length ){
            $('.ti-guided-header, .ti-reviews').hide();
        }else {
            $('.ti-guided-header, .ti-reviews').show();
        }
        if ( !$('.ti-option[data-feature*="self"]:visible').length ){
            $('.ti-self-header').hide();
        }else {
            $('.ti-self-header').show();
        }
    
        // udpate sticky variable
        tiFixMe = $('.package-content').offset().top;
        $('.ti-filter.ti-filter-v1').each(function(){
            //Checking if no options are visible
            if($(".ti_package_box").is(":visible") == false){
                $(".ti-no-matches").show();
            }else{
                $(".ti-no-matches").hide();
            }
        });
    }
    function tiSort(){
        //Start with 1
        for (i = 0; i <= $('.package-item').length; i++) {
            //Looking at the class on the ti_package_options to see which sort by was chosen
            if($(".package-content").hasClass("high") || $(".package-content").hasClass("low") || $(".package-content").hasClass("most-popular")){
                //High to low
                if($(".package-content").hasClass("high")){
                    $('.package-item[data-high='+i+']').appendTo($('.package-content')).insertBefore("#ti_package_general_admission");
                }
    
                //Low to High
                if($(".package-content").hasClass("low")){
                    $('.package-item[data-low='+i+']').appendTo($('.package-content')).insertBefore("#ti_package_general_admission");
                }
    
                //Most Popular
                if($(".package-content").hasClass("most-popular")){
                    $('.package-item[data-most-popular='+i+']').appendTo($('.package-content')).insertBefore("#ti_package_general_admission");
                }
            }else{
                $('.package-item[data-high='+i+']').appendTo($('.package-content')).insertBefore("#ti_package_general_admission");
            }
        }
        var leftPercentage = 0;
        for (i = 0; i <= $('.pcc-slider__slide').length; i++) {
            //Looking at the class on the ti_package_options to see which sort by was chosen
    
            if($(".pcc-slider").hasClass("high") || $(".pcc-slider").hasClass("low") || $(".pcc-slider").hasClass("most-popular")){
                //High to low
                if($(".pcc-slider").hasClass("high")){
                    $('.pcc-slider__slide[data-high='+i+']').css("left", leftPercentage + "%").appendTo('.packages-mobile-slides__list');
                    leftPercentage += 83;
                }
    
                //Low to High
                if($(".pcc-slider").hasClass("low")){
                    $('.pcc-slider__slide[data-low='+i+']').css("left", leftPercentage + "%").appendTo('.packages-mobile-slides__list');
                    leftPercentage += 83;
                }
    
                //Most Popular
                if($(".pcc-slider").hasClass("most-popular")){
                    $('.pcc-slider__slide[data-most-popular='+i+']').css("left", leftPercentage + "%").appendTo('.packages-mobile-slides__list');
                    leftPercentage += 83;
                }
            }else{
                $('.pcc-slider__slide[data-high='+i+']').css("left", leftPercentage + "%").appendTo('.packages-mobile-slides__list');
                leftPercentage += 83;
            }
        }
    
        $("body").find("#ti_package_options").removeAttr("class");
        $('.ti-filter.ti-filter-v1').each(function(){
            //Checking if no options are visible
            if($(".ti_package_box").is(":visible") == false){
                $(".ti-no-matches").show();
            }else{
                $(".ti-no-matches").hide();
            }
        });
        $('.ti-sort .ti-filter[data-filter="sort-by"] .ti-filter-name').html('Sort By ' + '<span>: '+$('.ti-filter-opt.ti-applied').text()+'</span>');
    }
    $(document).ready(function(){
    
    
                // tablet
                if ( is_touch_device() ){
                    $('.ti-filter-name').click(function(){
                        $('.ti-filter-name').not($(this)).removeClass('open');
                        $('.ti-filter-options').not($(this).siblings('.ti-filter-options')).slideUp();
                        $(this).toggleClass('open');
                        $(this).siblings('.ti-filter-options').slideToggle();
                        //Checking if it is the seating filter opened
                        if($(this).parent().attr("data-filter") == "data-seating" && $(this).hasClass("open")){
                            $(this).parent().find(".ti-info-container").show();
                        }else{
                            if($(this).parent().attr("data-filter") == "data-seating" && !$(this).hasClass("open")){
                                $(this).parent().find(".ti-info-container").hide();
                            }
                        }
                    });
    
                    // close filters on body click
                    $('.ti-filter').click(function(){
                        event.stopPropagation();
                    });
    
                    $('body').click(function(){
                        $('.ti-filter-name').removeClass('open');
                        $('.ti-filter-options').hide();
                    });
                }else {// desktop
                    $('.ti-filter').click(function(){
                        event.stopPropagation();
                    });
                    $('body').click(function(){
                        $('.ti-filter-name').removeClass('open');
                        $('.ti-filter-options').hide();
                    });
                    $('.ti-filter:not([data-filter="sort-by"])').mouseenter(function(){
                        $(this).find('.ti-filter-name').addClass('open');
                        $(this).find('.ti-filter-options').show();
    
                        //Adding a class to the parent to show/hide the ti-info-container
                        $(this).parent().addClass('ti-open');
    
                        //Showing the ti-info-container
                        $(this).find(".ti-info-container").show();
                    }).mouseleave(function(){
                        $(this).find('.ti-filter-name').removeClass('open');
                        $(this).find('.ti-filter-options').hide();
                        $(this).parent().removeClass('ti-open');
    
                        //Hidding the ti-info-container
                        $(this).find(".ti-info-container").hide();
                    });
                    //Sort by
                    $('.ti-filter[data-filter="sort-by"]').click(function(){
                        if(!$(this).find('.ti-filter-name').hasClass('open')){
                            $(this).find('.ti-filter-name').addClass('open');
                            $(this).find('.ti-filter-options').show();
    
                            //Adding a class to the parent to show/hide the ti-info-container
                            $(this).parent().addClass('ti-open');
    
                            //Showing the ti-info-container
                            $(this).find(".ti-info-container").show();
                        }else{
                            $(this).find('.ti-filter-name').removeClass('open');
                            $(this).find('.ti-filter-options').hide();
                            $(this).parent().removeClass('ti-open');
    
                            //Hiding the ti-info-container
                            $(this).find(".ti-info-container").hide();
                        }
                    });
                }
    
                var activeLabel
    
                $(".ti-filter-opt").mouseenter(function(){
                    //Finding the for attribute
                    activeLabel = $(this).find("label:not('.ti-faux-input')").attr("for");
                    //Making the active label show the correct info
                    $(this).parent().next().find("div[for="+activeLabel+"]").css("display", 'block');
                    $(this).parent().next().find("div[for="+activeLabel+"]").addClass("ti-showing");
                }).mouseleave(function(){
                    $(this).parent().next().find("div[for="+activeLabel+"]").css("display", 'none');
                    $(this).parent().next().find("div[for="+activeLabel+"]").removeClass("ti-showing");
                });
    
                $(".ti-filter-opt:not(.ti-disabled)").change(function(){
                    //Checking if the input has ti-applied
                    if($(this).find(".ti-faux-input").hasClass("ti-applied") && $(this).parent().parent().attr("data-filter") == "data-seating" && !$(this).hasClass("ti-disabled")){
                        //Making the container show
                        $(this).parent().parent().find(".ti-info-container").show();
                        activeLabel = $(this).find("label:not('.ti-faux-input')").attr("for");
    
                        //Making the active label show the correct info
                        $(this).parent().next().find("div[for="+activeLabel+"]").show();
    
                        //Making the placeholder image hidden
                        if($("#seating-info").is(":visible") == true){
                            $("#seating-info").hide();
                        }
                    }else{
                        //Making the container show
                        //Checking if the open class is on the child label
                        if(!$(this).parent().parent().find(".ti-filter-name").hasClass("open")){
                            $(this).parent().parent().find(".ti-info-container").hide();
                        }else{
                        }
    
                        activeLabel = $(this).find("label:not('.ti-faux-input')").attr("for");
    
                        //Making the active label show the correct info
                        $(this).parent().next().find("div[for="+activeLabel+"]").hide();
    
                        //Making the placeholder image visible
                        if($("#seating-info").is(":visible") == false){
                            $("#seating-info").show();
                        }
                    }
                });
    
                //click checking if the show seating image is showing
                $("body").on("touchstart", ".ti-filter", function(){
                    if($(".ti-info-container").is(":visible") == true){
                        $(".ti-info-container").hide();
                    }
                });
    
                // apply filter functionality
                $('.ti-filter-opt input').change(function(){
                    // toggle class
                    if ( $(this).is(':checked') ){
                        $(this).closest('.ti-filter-opt').find('.ti-faux-input').addClass('ti-applied');
                        $(this).closest(".ti-filter-opt").find(".ti-faux-input").next().addClass("ti-filter-applied");
    
                    }else {
                        $(this).closest('.ti-filter-opt').find('.ti-faux-input').removeClass('ti-applied');
                        $(this).closest(".ti-filter-opt").find(".ti-faux-input").next().removeClass("ti-filter-applied");
                    }
                    // update count of filters applied
                    var filApp = $(this).closest('.ti-filter').find('input:checked').length;
                    if ( filApp > 0 ) {
                        $(this).closest('.ti-filter').find('.ti-filter-count').text('('+filApp+')');
                    }else {
                        $(this).closest('.ti-filter').find('.ti-filter-count').text('');
                    }
    
                    // update content based on filters
                    tiFilter();
                });
    
                // apply filter functionality
                $('.ti-filter[data-filter="sort-by"] .ti-filter-opt input').change(function(){
                    //Removing the selected input classes
                    if($("body").find("#tiFilters .ti-applied").length || $("body").find(".ti-filter .ti-applied").length){
                        $("#tiFilters .ti-applied, .ti-filter .ti-applied").each(function(){
                            $(this).removeClass("ti-applied");
                        });
                        $("#tiFilters .ti-filter-applied, .ti-filter .ti-filter-applied").each(function(){
                            $(this).removeClass("ti-filter-applied");
                        });
                    }
    
                    // toggle class
                    if ( $(this).is(':checked') ){
                        //$(this).not($(this)).prop("checked", false);
                        //Unchecking an already checked option
                        $(this).closest('.ti-filter-opt').find('.ti-faux-input').addClass('ti-applied');
                        $(this).closest(".ti-filter-opt").find(".ti-faux-input").next().addClass("ti-filter-applied");
    
                        //Adding the ti-applied class for mobile "hover" functionality
                        $(this).parent().parent().addClass("ti-applied");
    
                        //Making sure the filter name does not have the open class
                        $(this).parent().parent().parent().parent().find(".ti-filter-name").removeClass("open");
    
                        //Closing the drawer
                        $(this).parent().parent().parent().hide();
    
                        //Grabing the ID of the clicked sort by option
                        $("body").find(".package-content, .pcc-slider").addClass($(this).attr("id"));
                    }else {
                        $(this).closest('.ti-filter-opt').find('.ti-faux-input').removeClass('ti-applied');
                        $(this).closest(".ti-filter-opt").find(".ti-faux-input").next().removeClass("ti-filter-applied");
    
                        //Grabing the ID of the clicked sort by option and removing it from that class
                        $("body").find(".package-content, .pcc-slider").removeClass($(this).attr("id"));
    
                        //Removing the ti-applied class for mobile "hover" functionality
                        $(this).parent().parent().removeClass("ti-applied");
                    }
    
                    // update count of filters applied
                    var filApp = $(this).closest('.ti-filter').find('input:checked').length;
                    if ( filApp > 0 ) {
                        $(this).closest('.ti-filter').find('.ti-filter-count').text('('+filApp+')');
                    }else {
                        $(this).closest('.ti-filter').find('.ti-filter-count').text('');
                    }
    
                    // update content based on filters
                    tiSort();
                });
    
                // remove filter functionality
                $('body').delegate('.ti-filter-app-button', 'click', function(){
                    $('.ti-filter[data-filter="'+$(this).attr('data-filter')+'"]').find('input[value="'+$(this).attr('data-val')+'"]').attr('checked',false).change();
                });
    
                // remove all filters
                $('#tiClear').click(function(){
                    $('#tiFilters input').each(function(){
                        $(this).attr('checked',false).change();
                    });
                });
    
                //Adding the overlay for mobile
                $("<div class='ti-overlay'></div>").prependTo(".main-content");
    
    
        //Mobile
        $("body").on("click, touchstart", ".ti-filter-label", function(){
            //Adding a class to the filters container
            if(!$("#tiFilters").hasClass("ti-shown")){
                $("#tiFilters").addClass("ti-shown");
                $("body").addClass("ti-shown");
                $('html, body').animate({
                    scrollTop: $(".ti-filter-close").offset().top
                }, 1000);
            }
            //Checking if the overlay is showing
            if(!$(".ti-overlay").hasClass("ti-shown")){
                $(".ti-overlay").addClass("ti-shown");
            }
        });
    
        //Closing the filters
        $(document).on("click, touchstart", ".ti-filter-close, .ti-overlay", function(){
            $(".ti-info-container").hide();
            //Checking if the filters have the showing class
            if($("#tiFilters").hasClass("ti-shown")){
                $("#tiFilters").removeClass("ti-shown");
                $("body").removeClass("ti-shown");
            }
            //Checking if the overlay is showing
            if($(".ti-overlay").hasClass("ti-shown")){
                $(".ti-overlay").removeClass("ti-shown");
            }
        });
        var highs = [];
        var lows = [];
    
        $('.package-item').each(function(e,i){
           var adult = Number($(this).find('.adult-price').text().replace( /^\D+/g, ''));
           var child = Number($(this).find('.child-price').text().replace( /^\D+/g, ''));
    
           highs.push(adult);
           lows.push(child);
        });
        highs.sort(function(a, b){return b-a});
        lows.sort(function(a, b){return a-b});
        $('.package-item').each(function(e,i){
          var adult = Number($(this).find('.adult-price').text().replace( /^\D+/g, ''));
          var child = Number($(this).find('.child-price').text().replace( /^\D+/g, ''));
          $(this).attr('data-high', highs.indexOf(adult) );
          $(this).attr('data-low', lows.indexOf(child) );
        });
    
        var mobilehigh =[];
        var mobilelow = [];
    
        $('.pcc-slider__slide').each(function(e,i){
           var adult = Number($(this).find('.adult-price').text().replace( /^\D+/g, ''));
           var child = Number($(this).find('.child-price').text().replace( /^\D+/g, ''));
    
           mobilehigh.push(adult);
           mobilelow.push(child);
        });
        mobilehigh.sort(function(a, b){return b-a});
        mobilelow.sort(function(a, b){return a-b});
    
        $('.pcc-slider__slide').each(function(e,i){
          var adult = Number($(this).find('.adult-price').text().replace( /^\D+/g, ''));
          var child = Number($(this).find('.child-price').text().replace( /^\D+/g, ''));
          $(this).attr('data-high', mobilehigh.indexOf(adult) );
          $(this).attr('data-low', mobilelow.indexOf(child) );
        });
    });

  })(jQuery);
});

function is_touch_device() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}

